import { useEffect, useState } from 'react';
import { marketingSiteService } from '../../services/apiService';
import { useAuthToken } from '../../hooks/useAuthToken';
import { isDeployInProgress } from './useReleaseStatus';

const POLL_MS = 3000;

/** Follows one deploy (from a save or Deploy to production) until it finishes. */
export const useDeployStatus = (initialDeploy) => {
  const ensureToken = useAuthToken();
  const [deploy, setDeploy] = useState(initialDeploy);

  useEffect(() => {
    setDeploy(initialDeploy);
  }, [initialDeploy]);

  const id = deploy?.id;
  const inProgress = isDeployInProgress(deploy);

  useEffect(() => {
    if (!id || !inProgress) return undefined;
    let cancelled = false;
    const timer = setInterval(async () => {
      try {
        await ensureToken();
        const response = await marketingSiteService.getDeploy(id);
        if (!cancelled) setDeploy(response.data);
      } catch {
        // Transient failures are fine; the next poll retries. A lost record (server restart)
        // leaves the last known state, and the release bar still reads CircleCI directly.
      }
    }, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [id, inProgress, ensureToken]);

  return deploy;
};
